import { isAllowedCookie } from './isAllowedCookie';

export const clearRevokedCookies = () => {
  if (!window.OneTrust || !window.OnetrustActiveGroups) {
    console.warn(
      'OneTrust is not initialized or active groups are not available.'
    );

    return;
  }

  const cookiesInStorage = document.cookie.split('; ').map(cookie => {
    const [name, value] = cookie.split('=');

    return { name, value };
  });

  cookiesInStorage.forEach(cookie => {
    if (!isAllowedCookie(cookie.name)) {
      document.cookie = `${cookie.name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
      document.cookie = `${cookie.name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${window.location.hostname}`;
    }
  });
};
